import { defineComponent, onBeforeUnmount, PropType, watch } from 'vue';

import useRootStore from '@/store/root';
import { Breadcrumb } from '@/types/Breadcrumb';

export default defineComponent({
  props: {
    breadcrumbs: { type: Array as PropType<Breadcrumb[]>, required: true },
  },
  setup(props) {
    const store = useRootStore();
    watch(
      () => props.breadcrumbs,
      () => store.changeBreadcrumbs(props.breadcrumbs)
    );

    onBeforeUnmount(() => {
      store.changeBreadcrumbs([]);
    });
  },
});
